import React, { useContext, useEffect, useState } from "react";
import child1 from "../images/child3_5.jpg"
import child2 from "../images/child6_8.jpg"
import child3 from "../images/child9_12.jpg"
import adult from "../images/adult.jpg"
import title from "../images/title_card.png"
import { Carousel, Row, Col } from "react-bootstrap";
import { isSmScreen, isXSmScreen, isSmallTouchScreen, isMdScreen } from "../CrackersUtil";
import { Link, useNavigate } from "react-router-dom";
import { CrackersContext } from "../CrackersContext";
import logo from "../images/logo.png"
import { height } from "@fortawesome/free-solid-svg-icons/fa0";
import { raiseGetRequest } from "../AxiosAPI";
// ff5c00
function HomePage(){
    const [windowSize, setWindowSize] = useState({width: window.innerWidth, height: window.innerHeight});
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [cursorStyle, setCursorStyle] = useState('default');
    const { setCrackersData, setAgentCode, serviceCommonData, setIsZeroCasePage } = useContext(CrackersContext);
    const navigate = useNavigate();

    const handleMouseOver = (e) => {
        setCursorStyle('pointer');
        e.target.style.borderRadius = "100%"
      };
    
      const handleMouseOut = (e) => {
        setCursorStyle('default');
        e.target.style.borderRadius = "25%"
      };

    const homePageNavigation = (filterOrder) => {
        const queryParams = new URLSearchParams({
            filter: filterOrder,
            agent_id: serviceCommonData["default_agent_id"]
        }).toString();
        navigate(`/web/crackers?${queryParams}`);
    };

    const mpSbsImg = {
        width: isSmallScreen ? '90px' : '120px',
        height: isSmallScreen ? '90px' : '120px',
        marginBottom: isSmallScreen ? '20%' : '8%',
        borderRadius: '25%'
      }

    const hpTitleStyle =  {
        fontSize: "12vw",
        whiteSpace : "nowrap",
        overflow: "hidden",
        // lineHeight: "220px",
        color: "#FF5C00",
        textShadow: isSmallScreen ? "0 10px 7px rgba(0,0,0,0.4),0 -3px 1px #fff" : "0 10px 7px rgba(0,0,0,0.4),0 -10px 1px #fff",
        letterSpacing: "-3px",
        userSelect: "none",
        marginBottom : "0px",
        height: isSmallScreen ? "80px" : "auto",
      }

      const logoStyle = {
        height : isSmallScreen ? "100px" : "300px",
        // marginRight : isSmallScreen ? "-40px" : "-270px"
      }

    useEffect(() => {
        setIsZeroCasePage(false);
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
            setIsSmallScreen((isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth)) ? true : false);
        };
        setCrackersData(null);
        // setAgentCode(null);

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return(
        <>
            {/* <div style={{textAlign:'center', color: "#000000"}}>
                <h1 style={{color : "#FF9900"}}>Welcome to</h1>
            </div> */}
            <div className="mp_ctg" style={{height:'auto', justifyContent:'center'}}>
                    {/* <h3 className='hp-title' style={hpTitleStyle}><img src={logo} alt="Logo" style={logoStyle} />racklecart</h3> */}
                    <img src={title} alt="Logo" style={logoStyle} /><br></br>
                    {/* <span style={{fontWeight : "bold", fontSize : isSmallScreen ? "14px" : "18px", color : "#FF9900"}}>Your Online Fireworks Store!</span> */}
                {/* {
                    isSmallScreen ? (
                        <Row>
                            <div>
                                <h1 style={{color: "#000000"}}>About US</h1>
                                <span style={{fontSize : "20px", color: "#000000"}}>Warm greetings from <b>CrackleCart!</b> We make it easy for you to purchase firecrackers at wholesale or retail prices. We never compromise on quality, ensuring a vibrant bloom to your festivities.</span>
                            </div>
                            <div>
                                <h1 style={{color: "#000000"}}>Delivery Procedure</h1>
                                <span style={{fontSize : "20px", color: "#000000"}}>We ship your order through a parcel service that operates in your area or the nearest location. Once your shipment is dispatched, you will need to pick it up from the designated parcel service vendor after making the payment for transportation.</span>
                            </div>
                        </Row>
                    ) : (
                        <Row>
                            <Col lg={12}>
                                <div>
                                    <h1 style={{color: "#000000"}}>About US</h1>
                                    <span style={{fontSize : "20px", color: "#000000"}}>Warm greetings from <b>CrackleCart!</b> We make it easy for you to purchase firecrackers at wholesale or retail prices. We never compromise on quality, ensuring a vibrant bloom to your festivities.</span>
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div>
                                    <h1 style={{color: "#000000"}}>Delivery Procedure</h1>
                                    <span style={{fontSize : "20px", color: "#000000"}}>We ship your order through a parcel service that operates in your area or the nearest location. Once your shipment is dispatched, you will need to pick it up from the designated parcel service vendor after making the payment for transportation.</span>
                                </div>        
                            </Col>
                        </Row>
                    )
                } */}
                <h1 style={{color: "#000000", marginTop: "3%"}}>Explore by Age</h1>
                {isSmallScreen ? (
                    <Carousel interval={3000}>
                        <Carousel.Item>
                            <div style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('All')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                <img style={mpSbsImg} src={adult}></img>
                                <Carousel.Caption>
                                    <h3 style={{color: "#000000"}}>Teens & Adults</h3>
                                </Carousel.Caption>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('For kids(age 9-12)')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                <img style={mpSbsImg} src={child3}></img>
                                <Carousel.Caption>
                                    <h3 style={{color: "#000000"}}>Kids (9-12)</h3>
                                </Carousel.Caption>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('For kids(age 6-8)')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                <img style={mpSbsImg} src={child2}></img>
                                <Carousel.Caption>
                                    <h3 style={{color: "#000000"}}>Kids (6-8)</h3>
                                </Carousel.Caption>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('For kids(age 3-5)')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                <img style={mpSbsImg} src={child1}></img>
                                <Carousel.Caption>
                                    <h3 style={{color: "#000000"}}>Kids (3-5)</h3>
                                </Carousel.Caption>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                ):(
                    <div style={{margin: "2%"}}>
                        <Row>
                            <Col md={2}></Col>
                            <Col md={2}>
                                <div className="mp_lg_sbs_icns" style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('All')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                    <img style={mpSbsImg} src={adult}></img>
                                    <span style={{color: "#000000"}}>Teens & Adults</span>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="mp_lg_sbs_icns" style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('For kids(age 9-12)')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                    <img style={mpSbsImg} src={child3}></img>
                                    <span style={{color: "#000000"}}>Kids (9-12)</span>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="mp_lg_sbs_icns" style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('For kids(age 6-8)')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                    <img style={mpSbsImg} src={child2}></img>
                                    <span style={{color: "#000000"}}>Kids (6-8)</span>
                                </div>
                            </Col>
                            <Col md={2}>
                                <div className="mp_lg_sbs_icns" style={{ cursor: cursorStyle }} onClick={() => homePageNavigation('For kids(age 3-5)')} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                                    <img style={mpSbsImg} src={child1}></img>
                                    <span style={{color: "#000000"}}>Kids (3-5)</span>
                                </div>
                            </Col>
                            <Col md={2}></Col>
                        </Row>
                    </div>
                )}
                <div style={{marginTop : "2%"}}>
                    <BuildCrackersTiles isSmallScreen={isSmallScreen}/>
                </div>
                
                {/* <div style={{marginTop : "2%"}}>
                    <h1>Trending Crackers</h1>
                    <BuildCrackersTiles isSmallScreen={isSmallScreen}/>
                </div>
                
                <div style={{marginTop : "2%"}}>
                    <h1>Most Selling Crackers</h1>
                    <BuildCrackersTiles isSmallScreen={isSmallScreen}/>
                </div> */}
            </div>
        </>
    );
}

function BuildCrackersTiles({isSmallScreen}) {

    const { setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);
    const [crackersList, setCrackersList] = useState({});
    const categories = ["New Arrivals", "Trending Crackers", "Most Selling Crackers", "Best for child", "Best for Teens & Adults"];
    useEffect(() => {
        const fetchCrackers = async () => {
            var hpCrackers = await raiseGetRequest("/crackers/hp-crackers", null, setShowErrorToastStatus, setToastBody);
            if(hpCrackers && Object.keys(hpCrackers).length > 0) {
                setCrackersList(hpCrackers);
            } else {
                setCrackersList({});
            }
        }
        fetchCrackers();
        
    }, []);
    return(
        <>
           {
                categories.map((category, index) => (
                    <IterateCrackers key={"hp+" + category + "_" + index}
                        isSmallScreen={isSmallScreen}
                        category={category}
                        crackersList={crackersList[category]}
                        />
                ))
           } 
        </>
        
    );
}

function IterateCrackers ({isSmallScreen, category, crackersList}) {
    return (
        <>
            {
                crackersList ? (
                    <>
                        <h1 style={{marginTop : "2%"}}>{category}</h1>
                        {
                            isSmallScreen ? (
                                <Carousel interval={4000}>
                                {
                                    crackersList.map((crackers, index) => (
                                        <Carousel.Item key={crackers.id}>
                                            <Link to={`/web/crackers?fPage=hp&rType=${category}`} style={{textDecoration : "none"}}>
                                                <div key={"hp_" + index} style={{ textAlign: "center" }}>
                                                    <img style={{height : "120px", width : "120px"}} src={crackers.image_link ? crackers.image_link : "/client/images/Image_not_available.png"}></img>
                                                    <div style={{ marginTop: "10px", color: "#000000", fontSize: "1rem" }}>
                                                        <span>{crackers.name}</span>
                                                        <br></br>
                                                        <span><span style={{color : "red"}}>-85%</span> ₹{120}</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </Carousel.Item>
                                    ))
                                }
                                </Carousel>
                            ) : (
                                <Row>
                                    <Col md={1} lg={1}></Col>
                                    <Col md={10} lg={10}>
                                        <Row>
                                            {
                                                crackersList.map((crackers, index) => (
                                                    <BuildTiles key={"hp_" + index} crackers={crackers}
                                                                category={category}/>
                                                ))
                                            }
                                        </Row>
                                    </Col>
                                    <Col md={1} lg={1}></Col>
                                </Row>
                                
                            )
                        }
                    </>
                ) : (
                    null
                )
            }
            {/*  */}
        </>
    );
}

function BuildTiles({crackers, category}) {

    const [cItemHover, setCItemHover] = useState(false);
    const {activeCart} = useContext(CrackersContext);
    const handleMouseOver = () => setCItemHover(true);
    const handleMouseOut = () => setCItemHover(false);

    const crackerTileStyle = {
        display : "flex", 
        flexDirection : "column", 
        alignItems : "center", 
        color : "black", 
        // fontWeight : "bold",
        borderRadius: '10px',
        backgroundColor: cItemHover ? '#eee' : 'transparent',
    };

    return(
        <Col md={4} lg={2}>
            <Link to={`/web/crackers?fPage=hp&rType=${category}`} style={{textDecoration : "none"}}>
                <div style={crackerTileStyle} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
                    <img style={{height : "180px", width: "180px"}} src={crackers.image_link ? crackers.image_link : "/client/images/Image_not_available.png"}/>
                    <span>{crackers.name}</span>
                    <span><span style={{color : "red"}}>-{Math.round((crackers.offer_price / crackers.mrp) * 100)}%</span> ₹{crackers.offer_price}</span>
                </div>
            </Link>
        </Col>
    );
}

export default HomePage;